import { render, staticRenderFns } from "./PersonalCollections.vue?vue&type=template&id=3a5863a3&scoped=true&"
import script from "./PersonalCollections.vue?vue&type=script&lang=js&"
export * from "./PersonalCollections.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCollections.vue?vue&type=style&index=0&id=3a5863a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5863a3",
  null
  
)

export default component.exports